<template>
  <v-card :loading="loading" class="mx-auto my-12" max-width="474"  min-height="550">
    <v-img height="250" :src="image"></v-img>

    <v-card-title>Blog Drops</v-card-title>

    <v-card-text>
<!--
      <v-row align="center" class="mx-0">
        <v-rating
          :value="4.5"
          color="amber"
          dense
          half-increments
          readonly
          size="14"
        ></v-rating>

        <div class="grey--text ml-4">4.5 (413)</div>
      </v-row>

      <div class="my-4 subtitle-1 black--text">
        * • Blog, Novidades
      </div>
-->

      <div>
        O
        <span style="font-family: 'Fontdiner Swanky', serif;"
          >VIOLENT NOISE</span
        >
        indica as novidades do cenário Underground.
      </div>
    </v-card-text>

    <v-divider class="mx-4"></v-divider>

    <!--

    <v-card-title>Veja as novidades</v-card-title>

    -->

    <v-card-actions>
      <v-btn color="deep-purple accent-4" text @click="showBlog">
        Veja as novidades
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
const image1 = require("@/assets/images/content/audience-celebration.jpg");

export default {
  data: () => ({
    image: image1,
    loading: false
  }),
  methods: {
    showBlog: function() {
      this.$store.commit("setIsBlogPost", true);
    }
  }
};
</script>

<style></style>
